<template>
  <div class="container-fluid">
    <h1>Artikelsortimente</h1>
    <div class="row">
      <div class="col">
        <h4>Sortimente</h4>
        <b-table @row-clicked="selectSort" :items="rows" :fields="fields">
        </b-table>
      </div>
      <div class="col">
        <h4>Artikel</h4>
        <b-table :item="articles" :fields="articlefields">
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import articles from '@/modules/articles.js'

export default {
  data() {
    return {
      start: 0,
      count: 50,
      rows: [],
      fields: [
        { key: 'map_id', label: 'ID' },
        { key: 'name', label: 'Name' }
      ],
      articles: [],
      articlefields: [
        { key: 'map_id', label: 'Artikel ID'}
      ]
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
      fetchData() {
        var self = this;
        articles.searchSelections(this,this.start,this.count,'',function(data) {
          self.rows = data;
        })
      },
      selectSort() {
        articles.viewparams.start = 0;
        articles.viewparams.value = '';
        articles.viewparams.filter = [];
      }
  }
}
</script>
